import { Form } from 'factorial-form'
import { EmployeeForSelectFragment } from 'generated/resources/graphql'
import { EmployeesEmployeeSelectorInput } from 'generated/resources/graphql'
import { computed, makeObservable, observable } from 'mobx'
import { $Values } from 'utility-types/dist/utility-types'

import i18n from 'modules/core/lib/i18n'

export const TIME_PERIODS = {
  CUSTOM_PERIOD: 'custom-period',
  DAILY: 'daily',
  DOES_NOT_REPEAT: 'does-not-repeat',
} as const

export type TimePeriod = $Values<typeof TIME_PERIODS>

declare type Values = {
  apply_on_days?: string
  start_date?: string
  end_date?: string
  employee_id?: number
  time_period?: string
  employeeSelection?: EmployeesEmployeeSelectorInput
}

class CommonSelectorsForm extends Form {
  employees?: EmployeeForSelectFragment[] | undefined
  employeeSelection: EmployeesEmployeeSelectorInput

  constructor(values: Values = {}) {
    super(values, {
      apply_on_days: 'string',
      start_date: 'string',
      end_date: 'string',
      employee_id: 'number',
      time_period: 'string',
    })
    this.employeeSelection = values.employeeSelection ?? { type: 'manual', ids: [] }

    makeObservable(this, {
      timePeriod: computed,
      isCustomPeriod: computed,
      doesNotRepeat: computed,
      employeeSelection: observable.ref,
    })
  }

  get timePeriod(): TimePeriod {
    return this.get('time_period').value
  }

  get isCustomPeriod(): boolean {
    return this.timePeriod === TIME_PERIODS.CUSTOM_PERIOD
  }

  get doesNotRepeat(): boolean {
    return this.timePeriod === TIME_PERIODS.DOES_NOT_REPEAT
  }

  validate(): boolean {
    this.resetErrors()

    // TODO: Remove this employee_id field and move the error to the component itself.
    if (this.employeeSelection.type === 'manual' && !this.employeeSelection?.ids?.length)
      this.get('employee_id').setErrors([
        i18n.t('shift_management.actions_sidepanel.errors.no_employees'),
      ])

    return !this.hasErrors
  }
}

export default CommonSelectorsForm
